<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (companySearchForm) {
  <div class="content-container">
    <div class="title w-100">
      <mwp-text-translate text="BENEFIT DOCUMENTS" jsonKey="benefitDocuments" />
    </div>
    <div class="content">
      <div class="col-3 mb-3">
        <mwp-companies-dropdown [form]="companySearchForm" [nameForControl]="'companyName'" [idForControl]="'companyID'" (emitSelectedCompany)="getCompanyResources($event)" />
      </div>
      @if (companySearchForm) {
      <div>
        <mwp-card-resource [resources]="resources" />
      </div>
      }
    </div>
  </div>
  }
</div>